import type { AiRelatedCompany, OCCompany } from 'bundles/connect/types';

export const selectCallConsoleAiCompanies = (state): AiRelatedCompany[] => {
  return state.callConsoleData.aiRelatedCompanies;
};

export const selectCallConsoleOcCompany = (state): OCCompany => {
  return state.callConsoleData.ocCompany;
};

export const selectCallConsoleConnectPropertyId = (state): number => {
  return state.callConsoleData.connectPropertyId;
};

export const selectCallConsolePropertyId = (state): string => {
  return state.callConsoleData.insightsProperty.propertyId;
};

export const selectCallListId = (state): number => state.callConsoleData.callListId;

export const selectCallListItemId = (state): number => state.callConsoleData.callListItemId;
